import restClient from "../restClient";


export const getPatchNotes = async () => {
  try {
    const response = await restClient.get(`/patch-notes?sort=createdAt:desc`);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getSearch = async (search) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`search?search=${search}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};